var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.page,{tag:"component",attrs:{"consentInfo":_vm.consentInfo,"errorType":_vm.errorType},on:{"navigate":_vm.navigate,"accept":_vm.accept,"cancel":_vm.cancel,"retry":_vm.retry}})
}
var staticRenderFns = []

export { render, staticRenderFns }